const STORAGE_KEY_DEVICE_ID = 'sporto_device_id';

function fallbackUuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const getOrCreateDeviceId = (): string => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return fallbackUuid();
  }
  let deviceId = localStorage.getItem(STORAGE_KEY_DEVICE_ID);
  if (!deviceId) {
    deviceId =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : fallbackUuid();
    localStorage.setItem(STORAGE_KEY_DEVICE_ID, deviceId);
  }
  return deviceId;
};

interface WindowWithMobileFlag extends Window {
  isMobileApp?: boolean;
}

export const getDeviceType = (): 'desktop' | 'mobile_view' | 'mobile_app' => {
  const win = window as WindowWithMobileFlag;
  const isMobileApp = win.isMobileApp || navigator.userAgent.includes('SportoMobileApp');
  if (isMobileApp) return 'mobile_app';

  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const isMobileView = mobileRegex.test(navigator.userAgent);

  return isMobileView ? 'mobile_view' : 'desktop';
};
